import { render, staticRenderFns } from "./PGPromo.vue?vue&type=template&id=c40216b0&scoped=true"
import script from "./PGPromo.vue?vue&type=script&lang=js"
export * from "./PGPromo.vue?vue&type=script&lang=js"
import style0 from "./PGPromo.vue?vue&type=style&index=0&id=c40216b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40216b0",
  null
  
)

export default component.exports